import {FANPAGE_REEL_FROM_FACEBOOK_SUCCESS} from "../../../types";


/**
 * @param {*} state
 * @param {*} action
 */
const FanpageReelsFromFaceBookReducer = (state = {}, action) => {

    switch (action.type) {
        case FANPAGE_REEL_FROM_FACEBOOK_SUCCESS:
            return {...state, action: action};
        default:
            return state;
    }
};

export {
    FanpageReelsFromFaceBookReducer
}